import { InfoItemProps } from "@/components/organisms";
import { defaultCurrencyFormat, defaultDecimalFormat } from "@/core/number";
import i18n from "@/i18n";

export const panelDescriptionSchema = (details: MyBrokerApi.Ship, language: string): InfoItemProps[] => [
    {
        key: "registration",
        label: i18n.t("InsuredGood.Details.Ship.Registration"),
        value: details.shipDescription?.registration,
    },
    {
        key: "length",
        label: i18n.t("InsuredGood.Details.Ship.Length"),
        value: defaultDecimalFormat(+details.shipDescription?.length, language, "m"),
    },
    {
        key: "numberSeats",
        label: i18n.t("InsuredGood.Details.Ship.NumberSeats"),
        value: details.shipDescription?.numberSeats,
    },
    {
        key: "hullMaterial",
        label: i18n.t("InsuredGood.Details.Ship.HullMaterial"),
        value: details.shipDescription?.hullMaterial,
    },
    {
        key: "sailArea",
        label: i18n.t("InsuredGood.Details.Ship.SailArea"),
        value: details.shipDescription?.sailArea && `${details.shipDescription?.sailArea}m2`,
    },
    {
        key: "manufacturer",
        label: i18n.t("InsuredGood.Details.Ship.Manufacturer"),
        value: details.shipDescription?.manufacturer,
    },
    {
        key: "boatValueExcVAT",
        label: i18n.t("InsuredGood.Details.Ship.BoatValueExcVAT"),
        value: defaultCurrencyFormat(+details.shipDescription?.boatValueExcVAT, language),
    },
];

export const panelRegistrationDatesSchema = (details: MyBrokerApi.Ship): InfoItemProps[] => [
    {
        key: "constructionYear",
        label: i18n.t("InsuredGood.Details.Ship.ConstructionYear"),
        value: details.shipRegistrationDates?.constructionYear,
    },
];

export const panelEngineSchema = (details: MyBrokerApi.ShipEngine, key: number, language: string): InfoItemProps[] => [
    {
        key: `brand${key}`,
        label: i18n.t("InsuredGood.Details.Ship.Brand"),
        value: details.brandEng,
    },
    {
        key: `power${key}`,
        label: i18n.t("InsuredGood.Details.Ship.Power"),
        value: details.powerEng,
    },
    {
        key: `fuel${key}`,
        label: i18n.t("Common.Fuel"),
        value: details.fuelEng?.name,
    },
    {
        key: `value${key}`,
        label: i18n.t("InsuredGood.Details.Ship.Value"),
        value: defaultCurrencyFormat(+details.valueEng, language),
    },
];
